<template>
   <m-geo-box geo-option="zip" :need-next="true" @go="goNext" >
     <m-geo-zip :geoType="5" :is-go.sync="isGo" @updateIsGo></m-geo-zip>
   </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoZip from '@/components/geo/MGeoZip'

  export default {
    components: {
      MGeoBox,
      MGeoZip
    },
    data () {
      return {
        isGo: false
      }
    },
    methods: {
      goNext () {
        this.isGo = true
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/order/GeoZip.vue